var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngelWings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 20",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 14 C16 10 9 7 2 5 C5 8 8 11 11 14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14 C18 8 14 4 9 2 C11 5 14 8 16 14Z",
    opacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14 C20 9 18 5 15 2 C16 6 18 9 20 14Z",
    opacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14 C19 16 15 18 11 19 C13 17 17 16 22 14Z",
    opacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngelWings);
export default __webpack_public_path__ + "static/media/angel-wings.74925d0fa77a7c14213ba3d18f8ddac1.svg";
export { ForwardRef as ReactComponent };